import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import { colors } from '../tokens'

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    // The buttons' extra room sits outside, so the icons stay where they were.
    margin: '-8px -8px -8px 0',
  },
  // 32×32 to click; the icon stays 16px.
  button: {
    width: 32,
    height: 32,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: 0,
    borderRadius: '8px',
    background: 'transparent',
    cursor: 'pointer',
    color: colors.navy,
    '&:hover': {
      color: colors.primary,
      background: colors.hover,
    },
  },
  icon: {
    width: 16,
    height: 16,
  },
})

/** Analytics + more-menu icon buttons in a card footer. */
const CardActions = ({ onAnalytics, onMenu }) => {
  const classes = useStyles()

  return (
    <span className={classes.root}>
      {onAnalytics && (
        <button
          type="button"
          title="Analytics"
          className={classes.button}
          onClick={onAnalytics}
        >
          <Icon icon="tabler:chart-bar" className={classes.icon} />
        </button>
      )}
      {onMenu && (
        <button
          type="button"
          title="More"
          className={classes.button}
          onClick={onMenu}
        >
          <Icon icon="tabler:dots-vertical" className={classes.icon} />
        </button>
      )}
    </span>
  )
}

export default CardActions
